module.exports = __webpack_public_path__ + "img/borussia1.307676a2.jpg";